<template>
	<!--
		Zero-height overlay so the grid never shifts when a filter is applied or cleared.
		The chip floats on the grid's top-right edge only while a filter is active.
	-->
	<div class="relative z-[5] h-0">
		<button
			v-if="isFiltered"
			type="button"
			class="group absolute right-2 top-0 inline-flex cursor-default h-6 -translate-y-1/2 items-center gap-1.5 rounded-full border-0 bg-blue-100 px-2 text-xs leading-none text-blue-800 shadow-[0_1px_3px_rgba(0,0,0,0.15)] hover:bg-blue-200"
			title="Clear all filters"
		>
			<i class="pi pi-filter !text-xs" />
			<span>Showing {{ visibleCount }} of {{ totalCount }} rows</span>
			<i class="pi pi-times !text-xs cursor-pointer opacity-70 group-hover:opacity-100" @click="$emit('clear')" />
		</button>
	</div>
</template>

<script setup lang="ts">
const props = defineProps<{
	visibleCount: number
	totalCount: number
	isFiltered: boolean
}>()

defineEmits<{
	(e: "clear"): void
}>()
</script>
